import PropTypes from 'prop-types';
import styled from 'styled-components';

export const Progress = styled.div`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  background-color: ${({ theme }) => theme.colors.disabled};

  &::after {
    content: '';
    display: block;
    width: ${({ progressStatus }) =>
      // eslint-disable-next-line no-nested-ternary
      progressStatus >= 100
        ? '100%'
        : progressStatus < 100 && progressStatus >= 0
        ? `${progressStatus}%`
        : '0%'};
    height: 10px;
    background-color: ${({ color }) => color || '#303030'};
  }
`;

Progress.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  progressStatus: PropTypes.number,
};

Progress.defaultProps = {
  color: '#303030',
  height: 10,
  progressStatus: 0,
};
